// Copyright (c) 2023 embyt GmbH. All rights reserved.
// Author: Marc Planeck

import * as React from "react";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Button } from "react-bootstrap";

import { isLocalhost } from "guiutils";

import { IState } from "states/states";
import { IAction, ActionType, raiseAction } from "actions";
import { DataState, RootPath } from "types";

declare const IS_CLOUD: boolean;

interface ISignupEntryExtProps {
  username: string;
}

interface ISignupEntryProps {
  isRfidLogin: boolean;
  loginDataState: DataState;
}

const mapStateToProps = (state: IState) => {
  const props: ISignupEntryProps = {
    isRfidLogin: state.router.rootPath === RootPath.RFID,
    loginDataState: state.scheduler.loginDataState,
  };
  return props;
};

interface ISignupEntryDispatch {
  onSignUpClick: (username: string) => void;
}

const mapDispatchToProps = (dispatch: (action: IAction<any>) => void) => {
  const dispatchProps: ISignupEntryDispatch = {
    onSignUpClick: (username: string) => {
      dispatch(raiseAction(ActionType.ACT_SIGNUP, username));
    },
  };
  return dispatchProps;
};

class SignupEntryComponent extends React.Component<
  ISignupEntryExtProps & ISignupEntryProps & ISignupEntryDispatch
> {
  public render() {
    if (!IS_CLOUD || this.props.isRfidLogin || this.props.loginDataState === DataState.SAVE_REQ) {
      return null;
    }

    return (
      <div className="mt-3">
        <Button
          id="perform-signup"
          variant="outline-success"
          onClick={() => {
            const username = !IS_CLOUD && isLocalhost() ? "admin" : this.props.username;
            this.props.onSignUpClick(username);
          }}
        >
          <FormattedMessage id="Perform Signup" />
        </Button>
      </div>
    );
  }
}

const SignupEntry = connect(mapStateToProps, mapDispatchToProps)(SignupEntryComponent);

export default SignupEntry;
